const classesMemory = {
  cfgMusic: -1,
  cfgRadio: -1,
  cfgSFX: -1,
  cfgSounds: -1,
  cfgIdentities: -1,
};

export default classesMemory;
